import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LScreen from "@components/LScreen";
import LText from "@components/LText";
import useInternetStatus from "@utils/internetStatus";
import { ActivityIndicator } from "react-native";

export const LoadingScreen = () => {
  const isOnline = useInternetStatus();

  return (
    <LScreen enableAutomaticTopPadding={true} pt="l3">
      {isOnline ? (
        <ActivityIndicator size="large" />
      ) : (
        <LBox flex={1} alignItems="center" justifyContent="center">
          <LIcon name="offline" size={42} mb="s3" />
          <LText variant="bodyL" textAlign="center">
            {`Unable to connect\nto the internet`}
          </LText>
        </LBox>
      )}
    </LScreen>
  );
};
